import { lazyRetry } from '@/shared/core/lazyRetry';

export const HospitalLogin = lazyRetry(() => import('./pages/HospitalLogin'));
export const HospitalCasesPage = lazyRetry(() => import('./pages/HospitalCasesPage'));
